<template>
  <div v-if="appLoading" class="h-[500px] flex justify-center items-center">
    <app-loader></app-loader>
  </div>
  <div v-else>
    <overview-heading :selected-currency="selectedCurrency"></overview-heading>
    <project-overview-list
      @update:filterBy="handleFilterByChange"
      @selected-currency="handleSelectedCurrency"
      @lock-data="lockMonthData = $event"
    ></project-overview-list>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import OverviewHeading from "./OverviewHeading.vue";
import ProjectOverviewList from "./ProjectOverviewList.vue";

export default defineComponent({
  name: "ProjectOverview",
  components: { OverviewHeading, ProjectOverviewList },
  data() {
    return {
      showAdditionalInfo: false,
      selectedCurrency: null,
      filteredMonth: false,
      lockMonthData: null,
    };
  },

  computed: {
    appLoading() {
      return this.$store.getters["pmLocalModules/appLoading"];
    },
    isEditButton() {
      return this.$store.getters["hrResources/isEditButton"];
    },
    isEditPmLocal() {
      return this.$store.getters["hrResources/isEditEmployee"];
    },
    currentPath() {
      return this.$route.path;
    },
    pmLocalID() {
      return this.$store.getters["pmLocalModules/isPmLocalID"];
    },
    shouldDisableInput() {
      // Add your condition to disable the input element here
      return (
        this.currentPath === "/edit-pm-local" &&
        this.isEditPmLocal &&
        !this.isEditButton
      );
    },
  },
  methods: {
    handleFilterByChange(value) {
      this.showAdditionalInfo = value === "Monthly";
      this.filteredMonth = value === "Monthly";
    },
    handleSelectedCurrency(value) {
      this.selectedCurrency = value;
    },
    getSingleOffice(id) {
      if (this.pmLocalID) {
        const payload = {
          load_page: true,
          pmLocalID: id,
        };
        this.$store.dispatch("pmLocalModules/getSinglePmlocal", payload);
      }
    },
  },
  mounted() {},
  created() {
    this.getSingleOffice(this.pmLocalID);
    this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", false);
  },
});
</script>
